export const BANKRUPTCY_TYPE_OPTIONS = [
  "Chapter 7",
  "Chapter 11",
  "Chapter 12",
  "Chapter 13",
  "Chapter 15",
];
